import { Component } from '@angular/core';
import { HeaderService } from '@app/core/services/header.service';
import { ModalService } from '@app/core/services/modal.service';
import { TableComponent } from '@shared/components/table/table.component';
import { ODataService } from '@app/core/services/odata/odata.service';
import {
  DashboardServicerequestBaseComponent,
  ServiceRequestConfig
} from '@shared/modals/dashboard/query/service-request-base/service-request-base.component';
import { ODataType } from '@app/core/services/odata/types/odata-type';
import { createActions } from '@app/core/utils/service-request.helper';
import { dashboardCompleteModal, dashboardReplyModal, serviceRequestRemoveModal } from '@views/dashboard/list-views/util/dashboard-modals.util';

@Component({
  selector: 'app-dashboard-servicerequest-metercontrol',
  imports: [
    TableComponent
  ],
  templateUrl: './dashboard-servicerequest-metercontrol.component.html',
})
export class DashboardServicerequestMetercontrolComponent extends DashboardServicerequestBaseComponent {
  protected config: ServiceRequestConfig = {
    tableId: 'table-dashboard-query-reopen',
    titleKey: 'dashboard.servicerequest.metercontrol.title',
    odataType: ODataType.meterControl,
    customParams: { userResponse: '2', serviceRequestCode: '5' },
    activeColumns: ['meteringPointIdentification', 'serviceRequestCode', 'created', 'occurrence', 'createdBy', 'userResponse', 'actionResponse', 'status', 'reasonText'],
  };

  constructor(
    headerService: HeaderService,
    oDataService: ODataService,
    modalService: ModalService,
  ) {
    super(headerService, oDataService, modalService);
    this.initialize();
  }

  protected getActions() {
    return createActions(
      {
        getSelectedElements: () => this.selectedElements,
        openReplyModal: () => this.openReplyModal(),
        openCompleteModal: () => this.openCompleteModal(),
        openRemoveModal: () => this.openRemoveModal(),
      },
      ['reply', 'complete']
    );
  }

  public openCompleteModal(): void {
    this.modalService.show({
      ...dashboardCompleteModal,
      params: { actionType: 'serviceRequestAction', element: this.selectedElements[0] }
    }).subscribe(() => this.refreshTable());
  }

  public openReplyModal(): void {
    this.modalService.show({
      ...dashboardReplyModal,
      params: { actionType: 'metercontrol', element: this.selectedElements[0] }
    }).subscribe(() => this.refreshTable());
  }
  public openRemoveModal(): void {
      this.modalService.show({
        ...serviceRequestRemoveModal,
        params: { element: this.selectedElements[0] }
      }).subscribe(() => this.refreshTable());
    }
}

